<div class="container grow columns center middle m-1">
  <mat-spinner diameter="50"></mat-spinner>
  @if (currentMessageKey) {
    <div animate.enter="fade-slide-enter" animate.leave="fade-slide-leave" class="loading-message">
      {{ currentMessageKey | translate }}
    </div>
  }
</div>
